<template>
  <div @mouseover="focus" @mouseleave="blur">
    <font-awesome-icon :icon="faIcon?.icon" class="tw-text-[18px]" :spin="faIcon?.icon?.spin" />
  </div>
</template>

<script>
import { computed, ref } from "vue";

export default {
  name: "NavLeftFooterIcon",
  props: {
    icon: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const active = ref(false);

    const blur = () => (active.value = false);

    const faIcon = computed(() =>
      active.value ? props.icon?.hover || props.icon?.default : props.icon?.default
    );

    const focus = () => (active.value = true);

    return {
      blur,
      faIcon,
      focus,
    };
  },
};
</script>
